import { Component, EventEmitter, Output } from "@angular/core";
import { UserRoleAndPermissions } from "@apiserver-rest/ponder-auth-client-base";

@Component({
    template: "",
    standalone: false
})
export class AdminEvents {
    @Output()
    public editUserEvent: EventEmitter<UserRoleAndPermissions> = new EventEmitter();

    @Output()
    public deleteUserEvent: EventEmitter<UserRoleAndPermissions> = new EventEmitter();

    @Output()
    public undeleteUserEvent: EventEmitter<UserRoleAndPermissions> = new EventEmitter();

    @Output()
    public viewTaskEvent: EventEmitter<string | undefined> = new EventEmitter();
}